import { API_BASE_URL } from '../config';

const baseUrl= API_BASE_URL;

export const getPlacenotes = async (token) => {
  const response = await fetch(`${baseUrl}users/placenotes`, {
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
    },
  });

  if (!response.ok) {
    throw new Error("Failed to fetch bookings to rate");
  }

  return await response.json();
};

export const submitSpaceRating = async (bookingId, ratings, token) => {
  const response = await fetch(`${baseUrl}users/placenotes`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      Authorization: `Bearer ${token}`,
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      booking_id: bookingId,
      ...ratings,
    }),
  });

  const data = await response.json();

  if (!response.ok) {
    throw new Error(data.message || "Failed to submit ratings");
  }

  return data; // Return the full response data
};

// export const submitSpaceRating = async (bookingId, ratings, token) => {
//   const response = await fetch(`${baseUrl}users/placenotes`, {
//     method: "POST",
//     headers: {
//       "Content-Type": "application/json",
//       Authorization: `Bearer ${token}`,
//     },
//     body: JSON.stringify({
//       booking_id: bookingId,
//       equipments: ratings.equipmentsRating,
//       location: ratings.locationRating,
//       quality_price: ratings.qualityPriceRating,
//       quality_services: ratings.servicesRating,
//     }),
//   });

//   if (!response.ok) {
//     const errorData = await response.json();
//     throw new Error(errorData.message || "Failed to submit ratings");
//   }

//   return await response.json();
// };

// export const getPlacenotes = async (authToken) => {
//   const url = `${baseUrl}users/placenotes`;

//   try {
//     const response = await fetch(url, {
//       method: "GET",
//       headers: {
//         "Content-Type": "application/json",
//         Authorization: `Bearer ${authToken}`,
//         Accept: "application/json",
//       },
//     });

//     if (!response.ok) {
//       throw new Error(`Error ${response.status}: ${response.statusText}`);
//     }

//     const data = await response.json();
//     return data;
//   } catch (error) {
//     console.error("Failed to fetch placenotes:", error);
//     throw error;
//   }
// };
